import variables from "../variables";
import constants from "../constants";
import people, {currentPlayer} from "../people/people";
import images, {getRandomImage} from "../images";
import { toast } from "react-toastify";
import { store } from "../../app/store";
import {setBackground} from "../../app/projectSlice";

const timeStrings = [
    ['Start of', 'Middle of', 'End of'],
    ['Morning', 'Daytime', 'Evening']
];

export const changeTimeTo = (dayPart = 0, timePart = 0, days = 0) => {
    if (days !== 0) {
        const date = new Date(variables.game.date);
        variables.game.date = date.changeDay(days);
    }
    variables.game.time = [dayPart, timePart];
};

export const setBackGroundColor = (color="") => store.dispatch(setBackground(color));

export const addTimePart = (setWifeOccupation = false) => {
    let [timePart, dayPart] = variables.game.time;
    timePart += 1;
    if (timePart > 2) {
        timePart = 0;
        dayPart += 1;
    }
    if (dayPart > 2) {
        dayPart = 0;
        const date = new Date(variables.game.date);
        variables.game.date = date.changeDay(1);
    }
    variables.game.time = [timePart, dayPart];
    setWifeOccupation && people.wife.occupations.set();

    dayPart === 2
    && timePart === 0
    && currentPlayer.isWife()
    && people.player.set("money", people.player.money + constants.works.courier.salaryPerDay)
};

export const notify = (text="") => toast(text);

export const getOccupationPicture = () => {
    const img = images;
    const occObject = constants.wife.occupations[variables.wife.occupation];
    if (!occObject.images)
        return images.wife.appearance[variables.wife.appearance];
    const imgObject = eval("img." + occObject.images);
    return getRandomImage(imgObject);
};

export const setOccupation = (occupation = "") => {
    if (occupation === "") {
        variables.wife.occupation = "";
        variables.wife.occupationPicture = images.wife.appearance[variables.wife.appearance];
        return;
    }
    variables.wife.occupation = occupation;
    variables.wife.occupationPicture = getOccupationPicture();
};

export const probabilityWorked = (prob = 0) => (prob >= Math.floor(Math.random() * 100));

export const getRandomItem = (itemsList = []) => (itemsList[Math.floor(Math.random()*itemsList.length)]);

export const paymentDay = () => {
    const date = new Date(variables.game.date);
    const day = date.getDate();
    if (day === constants.player.rentChangeStatusDay) variables.game.rentPayed = false;
    if (!variables.game.rentPayed)
        return day === constants.player.rentDay;
    else return false;
};

export const getTimeString = () => {
    return `${timeStrings[0][variables.game.time[0]]} ${timeStrings[1][variables.game.time[1]]}`
};

export const getDateString = () => {
    const date = new Date(variables.game.date);
    return `Today is ${date.getDate()} of ${date.getMonthName()}, ${date.getDayName()}`
};